import React from "react";
import ReactTooltip from 'react-tooltip';

const ManageButtonGroup = ({ artifactID, edit, deleteArtifact }) => {
  const downloadURL = `${process.env.REACT_APP_SERVER_URL}/public/artifacts/${artifactID}/download`;
  return (
    <div>
      <ReactTooltip />
      <div className="btn-group">
        <a
          href={downloadURL}
          className="btn btn-info btn-sm"
          data-tip="Download File"
        >
          <i className="fa fa-cloud-download" />
        </a>
        <a
          href="/"
          className="btn btn-danger btn-sm"
          data-tip="Delete Artifact"
          onClick={e => {
            e.preventDefault();
            deleteArtifact(artifactID);
          }}
        >
          <i className="fa fa-trash" />
        </a>
      </div>
    </div>
  );
};

export default ManageButtonGroup;



// WEBPACK FOOTER //
// ./src/pages/Artifacts/ManageButtonGroup.jsx